import {Input} from 'antd';
import {debounce} from 'lodash-es';
import React, {Dispatch, SetStateAction, FC} from 'react';
import './search.less';

import {ReactComponent as SearchIcon} from 'shared/assets/search.svg';

type TFetchCallback = (searchValue: string) => void;

interface ITableSearchProps {
    fetchCallback?: TFetchCallback;
    setSearch?: Dispatch<SetStateAction<string | null>>;
}

export const Search: FC<ITableSearchProps> = ({
    fetchCallback,
    setSearch,
}: ITableSearchProps) => {
    const handleSearchAction = debounce(event => {
        if (setSearch) setSearch(event.target.value);
        if (fetchCallback) fetchCallback(event.target.value);
    }, 500);

    return (
        <div className="table-search">
            <Input
                allowClear
                placeholder="Поиск"
                onChange={event => {
                    event.persist();
                    handleSearchAction(event);
                }}
                prefix={<SearchIcon className="table-search__icon" />}
            />
        </div>
    );
};
